import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const MusicIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M4.599 1a.75.75 0 0 1 .75-.75h9.318a.75.75 0 0 1 .75.75v10.25a2.924 2.924 0 1 1-1.5-2.555v-3.22H6.099v7.017a2.925 2.925 0 1 1-1.5-2.554zm1.5 2.976h7.818V1.75H6.099zm-1.5 8.516a1.424 1.424 0 1 0-2.848 0 1.424 1.424 0 0 0 2.847 0m9.318-1.242a1.425 1.425 0 1 0-2.85 0 1.425 1.425 0 0 0 2.85 0"
      clipRule="evenodd"
    />
  </svg>
);
MusicIcon.id = 'MusicIcon';
MusicIcon.displayName = 'MusicIcon';
export default MusicIcon;
